import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Icon } from "../Icon";

import styles from "./GlobalFooter.scss";

const GlobalFooterSocialMedia = forwardRef((props, ref) => {
  const { icon, href, labelText } = props;
  return (
    <a ref={ref} href={href} key={icon} className={styles["social-icon"]}>
      <Icon icon={icon} size={Icon.Size.small} />
      <span className={styles["social-icon-label"]}>{labelText}</span>
    </a>
  );
});

GlobalFooterSocialMedia.propTypes = {
  icon: PropTypes.elementType.isRequired,
  labelText: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

GlobalFooterSocialMedia.displayName = "GlobalFooter.SocialMedia";

export default GlobalFooterSocialMedia;
